export default {
  general: {
    settings: "Einstellungen",
    show_time: "Zeitanzeige anzeigen",
    show_seconds: "Sekunden anzeigen",
    show_search: "Suchleiste anzeigen",
    show_wallpaper: "Schaltfläche zum Überspringen des Hintergrundbilds anzeigen",
    show_bookmark: "Lesezeichen-Schaltfläche anzeigen",
    show_weather: "Wetter anzeigen",
    show_top_sites: "Häufig besuchte Seiten anzeigen",
    auto_change_background: "Hintergrund automatisch wechseln",
    auto_change_every: "Wechselintervall",
    days: "Tage",
    hours: "Stunden",
    minutes: "Minuten",
    interval_required: "Tage, Stunden und Minuten dürfen nicht alle 0 sein",
    sync_enabled: "Todo-Cloud-Synchronisierung",
    show_ai_chat: "KI-Chat-Schaltfläche anzeigen",
  },
  profile: {
    title: "Profil",
    logout: "Abmelden",
    sign_in: "Anmelden",
    sign_in_desc: "Bitte melden Sie sich an, um das volle Erlebnis freizuschalten",
    avatar_updated: "Avatar erfolgreich aktualisiert",
    nickname_updated: "Spitzname erfolgreich aktualisiert",
    avatar_size: "Avatar-Dateigröße darf 500 KB nicht überschreiten",
    login_required: "Sie müssen angemeldet sein, um Ihren Avatar zu aktualisieren",
    login_success: "Anmeldung erfolgreich",
    user_avatar: "Benutzer-Avatar",
    edit_avatar: "Avatar bearbeiten",
    save: "Speichern",
    cancel: "Abbrechen"
  },
  subscription: {
    title: "Abonnement",
    check: "Mein Abonnement prüfen",
    upgrade: "Abonnement upgraden",
    subscribe: "Tabby abonnieren",
    expired_on: "Abgelaufen am: {0}",
    expires_on: "Läuft ab am: {0}",
    plans: {
      premium: "Schalten Sie alles in Tabby frei — unbegrenzte Hintergrundbilder, benutzerdefinierte Hintergründe und exklusive Sammlungen.",
      pro: "Upgraden Sie Ihr Abonnement, um unbegrenztes Überspringen von Hintergrundbildern, benutzerdefinierte Hintergründe und exklusive Sammlungen freizuschalten.",
      free: "Abonnieren Sie, um unbegrenztes Überspringen von Hintergrundbildern, benutzerdefinierte Hintergründe und exklusive Sammlungen freizuschalten."
    }
  },
  wallpaper: {
    title: "Hintergrundbild",
    upload: "Benutzerdefiniertes Hintergrundbild hochladen",
    upgrade_required: "Upgraden Sie auf Pro/Premium-Plan, um die Funktion für benutzerdefinierte Hintergründe freizuschalten",
    images: "Bilder",
    hues: "Farbtöne",
    anims: "Animationen",
    diy: "Selbstgemacht",
    get_new: "Neues bekommen",
    upload_background: "Hintergrund hochladen",
    add: "Hinzufügen",
    remote_url: "Remote-Bild-URL",
    size_tip: "Kleinere Hintergrunddateien laden Tabs schneller. Die meisten Browser haben ein Dateigrößenlimit von 1,5 MB. Remote-URLs haben keine Einschränkungen.",
    please_login: "Bitte zuerst anmelden",
    click_to_upload: "Zum Hochladen klicken",
    video_gif_image: "Video, GIF oder Bild",
    background: "Hintergrund",
    or_enter_remote_background_url: "Oder geben Sie eine Remote-Hintergrund-URL ein",
    remote_url_placeholder: "https://example.com/image.jpg",
    custom_background_removed: "Benutzerdefinierter Hintergrund entfernt",
    failed_to_load_background: "Hintergrund konnte nicht geladen werden",
    using_default: "Verwende stattdessen Standardhintergrund",
    insufficient_storage: "Unzureichender Speicherplatz",
    upload_failed: "Upload fehlgeschlagen",
    success: "Erfolg",
    remote_background_added: "Remote-Hintergrund hinzugefügt",
    detecting_media_type: "Medientyp wird erkannt...",
    invalid_media_type: "Nicht erkannter Medientyp",
    video_load_failed: "Video kann nicht geladen werden, bitte überprüfen Sie, ob die URL korrekt ist"
  },
  rewards: {
    title: "Belohnungen",
    invite_friends: "Freunde einladen",
    get_access: "Laden Sie Freunde ein und erhalten Sie Rabatte auf Pro",
    total_invites: "Gesamte Einladungen",
    your_discount: "Ihr Rabatt",
    no_pro_yet: "Noch keiner",
    copy_link: "Einladungslink kopieren",
    copied: "Einladungslink kopiert!",
    copy_failed: "Link konnte nicht kopiert werden",
    invite_description: "Ein Freund registriert sich über Ihren Link",
    receive_credits: "Sie erhalten: 1 Einladung → 5% Rabatt, 2 → 8% Rabatt, 3 → 15% Rabatt, 4+ → 20% Rabatt · Jeder Freund erhält 5% Rabatt"
  },
  paywall: {
    title: "Tabby Pro",
    pro_active: "PRO AKTIV",
    expires: "läuft ab",
    free_plan: "KOSTENLOSER PLAN",
    tagline: "Schalten Sie volle Chat-Kontingente, Cloud-Todo-Sync und alle Wallpaper-Funktionen in dieser Erweiterung frei.",
    monthly: "MONATLICH",
    yearly: "JÄHRLICH",
    month_period: "/Monat",
    year_period: "/Jahr",
    billed_monthly: "Monatlich abgerechnet · jederzeit kündbar",
    billed_yearly: "Jährlich abgerechnet",
    checkout_usd: "Bezahlung",
    save_yearly: "17 % sparen gegenüber monatlich",
    best_value: "BESTES ANGEBOT",
    referral_price: "Empfehlungspreis",
    save: "sparen",
    subscribe_now: "Jetzt abonnieren",
    current_plan: "Aktueller Plan",
    processing: "Verarbeitung",
    waiting_title: "Warten auf Zahlung",
    waiting_desc: "Bitte schließen Sie die Zahlung im neu geöffneten Fenster ab.",
    payment_completed: "Zahlung abgeschlossen",
    having_issues: "Probleme",
    invite_save: "Freunde einladen und bei Pro sparen",
    sign_in_first: "Bitte zuerst anmelden",
    checkout_failed: "Zahlungssitzung konnte nicht erstellt werden",
    payment_failed: "Zahlung fehlgeschlagen",
    payment_wrong: "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.",
    success_msg: "Glückwunsch! Zahlung erfolgreich abgeschlossen",
    not_paid_msg: "Die Zahlung ist noch nicht abgeschlossen. Schließen Sie die Zahlung im Fenster ab oder versuchen Sie es erneut.",
    verify_failed: "Zahlungsstatus konnte nicht verifiziert werden. Versuchen Sie es erneut oder wenden Sie sich an den Support.",
    contact_email: "Kontakt per E-Mail: hi@tabbyio.com"
  },
  about: {
    title: "Über",
    version: "Version: 1.3.11",
    contact: "Kontaktieren Sie uns:",
    privacy_policy: "Datenschutzrichtlinie",
    terms_of_service: "Nutzungsbedingungen"
  },
  tabs: {
    general: "Präferenzen",
    profile: "Profil",
    wallpaper: "Hintergrundbild",
    rewards: "Belohnungen",
    about: "Über"
  },
  language: {
    title: "Sprache",
    en: "English",
    zh: "中文",
    de: "Deutsch",
    fr: "Français",
    pt: "Português",
    ru: "Русский",
    bn: "বাংলা",
    ja: "日本語",
    es: "Español"
  },
  buttons: {
    bookmark: "Lesezeichen",
    next_background: "Nächster Hintergrund",
    ai_chat: "KI-Chat",
    search_placeholder: "Suchen oder Strg + Enter für KI-Chat drücken...",
    attach: "Datei anhängen",
  },
  top_sites: {
    title: "Häufig besuchte Seiten",
    error: "Häufig besuchte Seiten konnten nicht geladen werden",
    empty: "Keine häufig besuchten Seiten gefunden"
  },
  greetings: {
    morning: "Guten Morgen",
    afternoon: "Guten Tag",
    evening: "Guten Abend",
    morning_message: "Ein neuer Tag beginnt. Wie kann ich Ihnen helfen?",
    afternoon_message: "Nachmittag – haben Sie Fragen, die Sie stellen möchten?",
    evening_message: "Am Abend – lassen Sie uns plaudern!"
  },
  intro: {
    your_portal: "Ihr Portal",
    for: "für",
    productivity: "Produktivität.",
    inspiration: "Inspiration.",
    photography: "Fotografie.",
    description: "Wo jeder neue Tab zu einem Tor wird",
    description_continued: "zu Eleganz, Produktivität und darüber hinaus.",
    add_to_chrome: "Zu Chrome hinzufügen",
    free: "Kostenlos",
    try_now: "Jetzt ausprobieren",
    screenshot: "Screenshot"
  }
}

